import type { BaseEntity } from '../../../base';
import type { TreeNode } from '../types';

export function defineTreeNodeProperties<TEntity extends BaseEntity>(
  advancedProperties: PropertyDescriptorMap & ThisType<TreeNode<TEntity>> = {},
) {
  return (node: Partial<TreeNode<TEntity>>) => {
    Object.defineProperties(node, {
      isLeaf: {
        enumerable: true,
        get(this: TreeNode<TEntity>) {
          const { composite, meta } = this.docState.document;
          if (composite) return true;

          const { childrenIds } = meta;
          return !childrenIds || childrenIds.length === 0;
        },
      },

      key: {
        enumerable: true,
        get(this: TreeNode<TEntity>) {
          return this.docState.document._id;
        },
      },

      title: {
        enumerable: true,
        get() {
          return this.docState.document.data.title;
        },
      },

      getContextMenuItems: {
        enumerable: true,
        value(this: TreeNode<TEntity>) {
          return null;
        },
      },
      ...advancedProperties,
    });
  };
}
